import React, { useEffect } from 'react';

const CalendlyWidget: React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="section bg-gradient-green" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
      <div className="container" style={{ maxWidth: '600px' }}>
        <div className="text-center" style={{ marginBottom: '5px' }}>
          <h2 id="contact" className="text-white" style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '20px', paddingTop: '120px', marginTop: '-100px' }}>
            Schedule Your Free Consultation
          </h2>
          <p className="text-white" style={{ fontSize: '1.25rem', opacity: 0.9, lineHeight: '1.6' }}>
            Book a free 30-minute consultation to discuss your goals and find the right program for you.
          </p>
        </div>

        <div style={{ marginBottom: '24px' }}>
          <img
            src="/natalie-speaking.jpeg"
            alt="Natalie Vinueza speaking on stage"
            style={{
              width: '100%',
              borderRadius: '12px',
              boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
              display: 'block',
            }}
          />
        </div>

        <div className="card" style={{ padding: '20px', textAlign: 'center' }}>
          {/* Calendly inline widget embed */}
          <div
            className="calendly-inline-widget"
            data-url="https://calendly.com/personacoach-info/30min"
            style={{ minWidth: '320px', height: '400px' }}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default CalendlyWidget;